import { NotificationService } from './notification.service';
import { User, UserPassword } from './../pages/settings/user/models/user.model';
import { Flags, UserBasic } from './../pages/settings/user/models/user-basic.model';
import { BaseService } from './base.service';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TableString } from '../models/table-string.model';
import { ReturnFlag } from '../models/return-flag';
import { HttpClient } from '@angular/common/http';
import { BASE_SERVICE_CONFIG_INJECTION_TOKEN, BaseServiceConfig } from './base.service.config';

@Injectable({
	providedIn: 'root'
})
export class UserService {

	//TODO: Make this Observable or some other event because it's not clear when this list is initialized in the application timeline.
	public users: User[];

	public initializeUsers(): void {
		const $this = this;

		this.getAllUsers().subscribe(
			(response) => {
				$this.users = response;
			},
			(error) => {
				console.error(error);


			}
		);
	}

	constructor(
		private _baseService: BaseService,
		private _http: HttpClient,
		private _notificationService: NotificationService,

		@Inject(BASE_SERVICE_CONFIG_INJECTION_TOKEN) private _config: BaseServiceConfig
	) {
		this.initializeUsers();
	}

	private readonly _getUserRequestEndpoint: string = "GetUser";

	public getUser(userId: number): Observable<User> {
		let url = `user/${this._getUserRequestEndpoint}?userId=${userId}`;

		return this._baseService.get(url);
	}

	private readonly _getUserByNameRequestEndpoint: string = "GetUserByName";

	public getUserByName(userName: string): Observable<User> {
		let url = `user/${this._getUserByNameRequestEndpoint}?userName=${userName}`;

		return this._baseService.get(url);
	}

	private readonly _getAllUsersRequestEndpoint: string = "GetAllUsers";

	public getAllUsers(): Observable<User[]> {
		let url = `user/${this._getAllUsersRequestEndpoint}`;
		return this._baseService.get(url);
	}

	private readonly _createUserRequestEndpoint: string = "CreateUser";

	public createUser(userName: string, email: string, password: string): Observable<{ success: boolean, message: string }> {
		let url = `user/${this._createUserRequestEndpoint}?userName=${userName}&email=${email}&password=${password}`;

		return this._baseService.post(url);
	}

	private readonly _saveUserRequestEndpoint: string = "SaveUser";

	public saveUser(user: User): Observable<{ success: boolean, message: string }> {
		let url = `user/${this._saveUserRequestEndpoint}`;

		return this._baseService.post(url, user);
	}

	private readonly _deleteUserRequestEndpoint: string = "DeleteUser";

	public deleteUser(userId: number): Observable<{ success: boolean, message: string }> {
		let url = `user/${this._deleteUserRequestEndpoint}?userId=${userId}`;

		return this._baseService.post(url);
	}

	private readonly _getUserBasicRequestEndpoint: string = "GetUserBasic";

	public getUserBasic(userId: number): Observable<UserBasic> {
		let url = `user/${this._getUserBasicRequestEndpoint}?userId=${userId}`;

		return this._baseService.get(url);
	}

	public sendEmail(userId: number): Observable<Flags> {
		let url = `user/SendUserCreationEmail?id=${userId}`;
		return this._baseService.post(url);
	}

	private readonly _getUsersSelectionDataRequestEndpoint: string = "GetUsersSelectionData";

	public getUsersSelectionData(): Observable<TableString[]> {
		let url = `user/${this._getUsersSelectionDataRequestEndpoint}`;

		return this._baseService.get(url);
	}

	public UpdatePassword(data: UserPassword): Observable<ReturnFlag> {
		let url = `user/UpdatePassword`;
		return this._baseService.post(url, data);
	}

	public UpdatePasswordClient(data: UserPassword): Observable<ReturnFlag> {
		return this._http.post<ReturnFlag>(this.getCorrectUrl("login/UpdatePasswordClient"),data);
	}

	public getCorrectUrl(url: string): string {
		if (url.indexOf('api') === -1) {
			url = '/api' + (url[0] === '/' ? '' : '/') + url;
		}
		return encodeURI(this._config.apiEndpoint + (url[0] === '/' ? '' : '/') + url);
	}

}
